<script setup>
import {computed, defineProps} from "vue";
import {statesEvaluation} from "@/config/stateEvaluationMapping.js";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    status: {
        type: String,
        required: true
    },
    isInactive: {
        type: Boolean,
        default: false
    }
});

const componentName = computed(() => statesEvaluation[props.status.toLowerCase()]?.component || '');
const classNameState = computed(() => statesEvaluation[props.status.toLowerCase()]?.class || '');
const titleState = computed(() => statesEvaluation[props.status.toLowerCase()]?.value || '');

</script>

<template>
    <div :class="['stateComponent', classNameState, {'-is-inactive': isInactive}]">
        <component
            :is="componentName"
            :is-inactive="isInactive"
        />
        <span v-text="trans('shared.common.' + titleState)"></span>
    </div>
</template>

<style lang="scss" scoped>
    @use '~@/base/variables' as *;

    .stateComponent {
        display: flex;
        align-items: center;
        gap: 7px;
        border-radius: 5px;
        padding: 5px 10px;
        font-size: 14px;
        font-weight: 600;
        color: white;

        &.-is-ongoing {
            background-color: $purple500;
        }
        &.-is-validated {
            background-color: $green500;
        }
        &.-is-supervision {
            background-color: $pink500;
        }
        &.-is-conflicting {
            background-color: $yellow500;
        }
        &.-is-inactive {
            background-color: $gray400;
            color: $blue800;
        }
    }
</style>
